import "core-js/modules/es.array.every";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getGoodsAllocationList, goodsAllocationCreate, goodsAllocationUpdate, deleteGoodsAllocation, goodsAllocationFind, goodsAllocationSubmit, goodsAllocationCheck, getSellerAllList, getGoodsList } from '@/api/bairun/bianlidian'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import { mapGetters } from 'vuex';

var _this;

export default {
  name: 'BianlidianAllocation',
  components: {},
  computed: _objectSpread(_objectSpread({}, mapGetters('user', ['userInfo', 'token'])), mapGetters('stations', ['allStationMap', 'allStations'])),
  filters: {
    formatDate: function formatDate(time, format) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd');
      } else {
        return '';
      }
    },
    formatDateTime: function formatDateTime(time, format) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getSellerName: function getSellerName(id) {
      for (var i = 0; i < _this.sellerAllOptions.length; i++) {
        if (_this.sellerAllOptions[i].sellerId == id) {
          return _this.sellerAllOptions[i].sellerName;
        }
      }

      return '';
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getGoodsAllocationList,
      type: '',
      loading: false,
      multipleSelection: [],
      sellerAllOptions: [],
      goodsLoading: false,
      goodsOptions: [],
      dialogVisible: false,
      goodsAllocationDetailTableData: [],
      spuNo: '',
      formData: {
        allocationNo: '',
        outSellerId: '',
        outSellerName: '',
        intSellerId: '',
        inSellerName: '',
        allocationRemark: '',
        // 调出说明
        acceptRemark: '',
        // 接收说明
        allocationStatus: ''
      },
      addRules: {
        outSellerId: [{
          required: true,
          message: '请选择调出便利店',
          trigger: 'blur'
        }],
        inSellerId: [{
          required: true,
          message: '请选择接收便利店',
          trigger: 'blur'
        }]
      },
      submitRules: {
        allocationRemark: [{
          required: true,
          message: '请输入调出说明',
          trigger: 'blur'
        }]
      },
      acceptRules: {
        acceptRemark: [{
          required: true,
          message: '请输入接收说明',
          trigger: 'blur'
        }],
        allocationStatus: [{
          required: true,
          message: '请选择接收结果',
          trigger: 'blur'
        }]
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var sellerAllOptions;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log('init');
                _context3.next = 3;
                return getSellerAllList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 3:
                sellerAllOptions = _context3.sent;
                _this.sellerAllOptions = sellerAllOptions.data.list;

                _this3.onSubmit();

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;

      if (this.searchInfo.optType == 1) {
        delete this.searchInfo.inSellerId;
        this.searchInfo.outSellerId = this.userInfo.sellerId;
      }

      if (this.searchInfo.optType == 2) {
        delete this.searchInfo.outSellerId;
        this.searchInfo.inSellerId = this.userInfo.sellerId;
      }

      this.loading = true;
      this.getTableData();
      this.loading = false;
    },
    onReset: function onReset() {
      debugger;
      this.searchInfo = {};
      this.onSubmit();
    },
    handleSelChange: function handleSelChange(val) {
      this.multipleSelection = val;
    },
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    // 输入调拨数
    onInputOutNum: function onInputOutNum(row) {
      debugger;

      if (!isNaN(row.outGoodsNum)) {
        row.outGoodsAmount = (parseInt(row.outGoodsNum) * parseFloat(row.goodsLatestCost)).toFixed(2);
      } else {
        row.outGoodsAmount = 0;
      }
    },
    // 输入接收数
    onInputAcceptNum: function onInputAcceptNum(row) {
      if (!isNaN(row.inGoodsNum)) {
        row.inGoodsAmount = (parseInt(row.inGoodsNum) * parseFloat(row.goodsLatestCost)).toFixed(2);
        row.differenceAmount = (row.outGoodsAmount - row.inGoodsAmount).toFixed(2);
        row.differenceNum = row.outGoodsNum - row.inGoodsNum;
      } else {
        row.inGoodsAmount = 0;
        row.differenceAmount = 0;
        row.differenceNum = 0;
      }
    },
    // 新增调拨
    onAdd: function onAdd() {
      var that = this;
      that.dialogVisible = true;
      that.type = 'add';
    },
    // 选择调出调入商店
    onSellerSel: function onSellerSel() {
      var that = this; // eslint-disable-next-line no-empty

      if (that.formData.outSellerId === that.formData.inSellerId) {
        that.$message({
          type: 'warning',
          message: '调出调入商店不能相同'
        });
      }
    },
    // 商品库搜索
    goodsSearch: function goodsSearch(query) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this4;
                that.handleGoodsSearch(query, '', function (res, isExit, queryName, goodsNo) {
                  debugger; // 默认添加

                  if (isExit && queryName === 'goodsNo') {
                    that.handleAddGoodsIn(that.goodsOptions[0]);
                    that.spuNo = '';
                    that.$refs.goodsSearchSelect.blur();
                    setTimeout(function () {
                      that.$refs.goodsSearchSelect.focus();
                    }, 50);
                  } // 扫条形码，不存在


                  if (!isExit && queryName === 'goodsNo') {
                    that.$message({
                      type: 'warning',
                      message: '商品不存在，请尝试根据名称搜索'
                    });
                  }
                });

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    handleGoodsSearch: function handleGoodsSearch(query, queryName, fn) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var that, param, result, isExit;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                console.log('handleGoodsSearch:' + queryName);
                that = _this5;

                if (!(query === '')) {
                  _context5.next = 5;
                  break;
                }

                that.goodsOptions = [];
                return _context5.abrupt("return");

              case 5:
                that.goodsOptions = [];
                that.goodsLoading = true;
                param = {};

                if (queryName && queryName === 'goodsName') {
                  param.goodsName = query;
                } else if (queryName && queryName === 'goodsNo') {
                  param.goodsNo = query;
                } else if (isNaN(query)) {
                  param.goodsName = query;
                  queryName = 'goodsName';
                } else {
                  param.goodsNo = query;
                  queryName = 'goodsNo';
                }

                _context5.next = 11;
                return getGoodsList({
                  'goodsNo': param.goodsNo,
                  'goodsName': param.goodsName,
                  'sellerId': that.formData.outSellerId,
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 11:
                result = _context5.sent;
                that.goodsLoading = false;
                debugger; // 存在

                isExit = false;

                if (result.data.list && result.data.list.length > 0) {
                  isExit = true; // 扫条形码

                  if (param.goodsNo) {
                    result.data.list.forEach(function (item) {
                      that.goodsOptions.push({
                        'sellerId': item.sellerId,
                        'goodsName': item.goodsName,
                        'spuNo': item.spuNo,
                        'goodsNo': param.goodsNo,
                        'goodsStock': item.goodsStock,
                        'goodsLatestCost': item.goodsLatestCost,
                        'outGoodsNum': 1,
                        'outGoodsAmount': 0,
                        'inGoodsNum': 0,
                        'inGoodsAmount': 0,
                        'categoryNo': item.categoryNo,
                        'categoryName': item.categoryName,
                        'supplierNo': item.supplierNo,
                        'supplierName': item.supplierName,
                        'goodsUnit': item.goodsUnit,
                        'goodsSpecification': item.goodsSpecification,
                        'remark': ''
                      });
                    });
                  } // 名称搜索


                  if (param.goodsName) {
                    result.data.list.forEach(function (item) {
                      that.goodsOptions.push({
                        'sellerId': item.sellerId,
                        'goodsName': item.goodsName,
                        'spuNo': item.spuNo,
                        'goodsNo': item.goodsNo,
                        'goodsStock': item.goodsStock,
                        'goodsLatestCost': item.goodsLatestCost,
                        'outGoodsNum': 1,
                        'outGoodsAmount': 0,
                        'categoryNo': item.categoryNo,
                        'categoryName': item.categoryName,
                        'supplierNo': item.supplierNo,
                        'supplierName': item.supplierName,
                        'goodsUnit': item.goodsUnit,
                        'goodsSpecification': item.goodsSpecification,
                        'remark': ''
                      });
                    });
                  }
                }

                if (fn) {
                  fn(result.data.list && result.data.list.length > 0 ? result.data.list : [], isExit, queryName, param.goodsNo);
                }

              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // 选中便利店商品
    onGoodsSel: function onGoodsSel() {
      debugger;
      var that = this;

      if (that.formData.sellerId === '') {
        that.$message({
          type: 'warning',
          message: '请选择便利店'
        });
        return;
      }

      var goods = this.goodsOptions.filter(function (item) {
        // eslint-disable-next-line eqeqeq
        return that.spuNo == item.spuNo;
      });

      if (goods.length > 0) {
        that.handleAddGoodsIn(goods[0]);
        that.spuNo = '';
      }
    },
    // 删除商品
    onDelGoods: function onDelGoods(row) {
      var that = this;
      that.goodsAllocationDetailTableData = that.goodsAllocationDetailTableData.filter(function (item) {
        return item.spuNo != row.spuNo;
      });
    },
    // 添加调整明细
    handleAddGoodsIn: function handleAddGoodsIn(goods) {
      var that = this;
      var isExit = false;

      if (goods.goodsStock <= 0) {
        that.$message({
          type: 'warning',
          message: '该商品库存数量为：' + goods.goodsStock + '，不能再调整了'
        });
        return;
      }

      that.goodsAllocationDetailTableData.forEach(function (item) {
        // eslint-disable-next-line eqeqeq
        if (goods.spuNo == item.spuNo) {
          isExit = true;
        }
      });

      if (!isExit) {
        that.goodsAllocationDetailTableData.splice(that.goodsAllocationDetailTableData.length, 0, JSON.parse(JSON.stringify(goods)));
      }
    },
    // 变更
    onUpdate: function onUpdate(row) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var that, res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                that = _this6;
                _context6.next = 3;
                return goodsAllocationFind({
                  'allocationNo': row.allocationNo,
                  'outSellerId': row.outSellerId,
                  'inSellerId': row.inSellerId
                });

              case 3:
                res = _context6.sent;

                // eslint-disable-next-line eqeqeq
                if (res.code == 0) {
                  that.goodsAllocationDetailTableData = res.data.list;
                }

                _this6.type = 'update';
                that.handleShowDialog(row);

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    // 双击查看
    onRowdbclick: function onRowdbclick(row) {
      var that = this;
      that.handleView(row);
    },
    // 查看
    onView: function onView(row) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var that;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                that = _this7;
                that.handleView(row);

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    handleView: function handleView(row) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var that, res;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                that = _this8;
                _context8.next = 3;
                return goodsAllocationFind({
                  'allocationNo': row.allocationNo,
                  'outSellerId': row.outSellerId,
                  'inSellerId': row.inSellerId
                });

              case 3:
                res = _context8.sent;

                // eslint-disable-next-line eqeqeq
                if (res.code == 0) {
                  that.goodsAllocationDetailTableData = res.data.list;
                }

                _this8.type = 'view';
                that.handleShowDialog(row);

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    // 提审
    onSubmitAudit: function onSubmitAudit(row) {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var that, res;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                that = _this9;
                _context9.next = 3;
                return goodsAllocationFind({
                  'allocationNo': row.allocationNo,
                  'outSellerId': row.outSellerId,
                  'inSellerId': row.inSellerId
                });

              case 3:
                res = _context9.sent;

                // eslint-disable-next-line eqeqeq
                if (res.code == 0) {
                  that.goodsAllocationDetailTableData = res.data.list;
                }

                _this9.type = 'submit';
                _this9.dialogVisible = true;
                that.handleShowDialog(row);

              case 8:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },
    // 接收
    onAccept: function onAccept(row) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var that, res;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                that = _this10;
                _context10.next = 3;
                return goodsAllocationFind({
                  'allocationNo': row.allocationNo,
                  'outSellerId': row.outSellerId,
                  'inSellerId': row.inSellerId
                });

              case 3:
                res = _context10.sent;

                // eslint-disable-next-line eqeqeq
                if (res.code == 0) {
                  that.goodsAllocationDetailTableData = res.data.list;
                  that.goodsAllocationDetailTableData.forEach(function (item) {
                    item.inGoodsNum = item.outGoodsNum;

                    if (item.goodsPrice > 0) {
                      item.exitGoodsPrice = true;
                    }
                  });
                }

                _this10.type = 'accept';
                that.handleShowDialog(row);
                _this10.formData.allocationStatus = '';

              case 8:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }))();
    },
    // 显示弹框
    handleShowDialog: function handleShowDialog(row) {
      debugger;
      this.dialogVisible = true;
      this.formData.allocationNo = row.allocationNo;
      this.formData.outSellerId = row.outSellerId;
      this.formData.outSellerName = this.$options.filters.getSellerName(row.outSellerId);
      this.formData.inSellerId = row.inSellerId;
      this.formData.inSellerName = this.$options.filters.getSellerName(row.inSellerId);
      this.formData.allocationRemark = row.allocationRemark;
      this.formData.acceptRemark = row.acceptRemark;
      this.formData.allocationStatus = row.allocationStatus;
    },
    // 删除
    onDelete: function onDelete(row) {
      var that = this;
      that.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        deleteGoodsAllocation({
          'allocationNo': row.allocationNo,
          'outSellerId': row.outSellerId,
          'inSellerId': row.inSellerId
        }).then(function (res) {
          // eslint-disable-next-line eqeqeq
          if (res.code == 0) {
            that.$message({
              type: 'success',
              message: res.msg
            });
            that.getTableData();
          } // eslint-disable-next-line handle-callback-err

        }, function (err) {});
      }).catch(function (err) {});
    },
    closeDialog: function closeDialog() {
      this.dialogVisible = false;
      this.goodsAllocationDetailTableData = [];
      this.goodsOptions = [];
      this.type = '';
      this.spuNo = '';
      this.formData = {
        allocationNo: '',
        outSellerId: '',
        outSellerName: '',
        intSellerId: '',
        inSellerName: '',
        allocationRemark: '',
        // 调出说明
        acceptRemark: '',
        // 接收说明
        allocationStatus: ''
      };
    },
    onDialogSubmit: function onDialogSubmit() {
      var that = this;
      debugger;

      switch (that.type) {
        case 'add':
          that.handleAdd();
          break;

        case 'update':
          that.handleUpdate();
          break;

        case 'submit':
          that.handleSubmit();
          break;

        case 'accept':
          that.handleAccpet();
          break;

        case 'view':
          that.closeDialog();
          break;

        default:
          break;
      }
    },
    enterDialogRepose: function enterDialogRepose(res) {
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '操作成功'
        });
        this.closeDialog();
        this.getTableData();
      }
    },
    // 新增保存
    handleAdd: function handleAdd() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var that;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                that = _this11;
                debugger;
                that.$refs['addForm'].validate(function (valid) {
                  if (valid) {
                    goodsAllocationCreate({
                      'outSellerId': parseInt(that.formData.outSellerId),
                      'inSellerId': parseInt(that.formData.inSellerId),
                      'list': that.goodsAllocationDetailTableData
                    }).then(function (res) {
                      if (res.code == 0) {
                        that.$message({
                          type: 'success',
                          message: res.msg
                        });
                        that.enterDialogRepose(res);
                      }
                    }, function (error) {});
                  }
                });

              case 3:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }))();
    },
    // 变更保存
    handleUpdate: function handleUpdate() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var that;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                that = _this12;
                debugger;
                goodsAllocationUpdate({
                  'allocationNo': that.formData.allocationNo,
                  'outSellerId': parseInt(that.formData.outSellerId),
                  'inSellerId': parseInt(that.formData.inSellerId),
                  'list': that.goodsAllocationDetailTableData
                }).then(function (res) {
                  if (res.code == 0) {
                    that.$message({
                      type: 'success',
                      message: res.msg
                    });
                    that.enterDialogRepose(res);
                  }
                }, function (error) {});

              case 3:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }))();
    },
    // 提交保存
    handleSubmit: function handleSubmit() {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var that;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                that = _this13;
                debugger;
                that.$refs['submitForm'].validate(function (valid) {
                  if (valid) {
                    goodsAllocationSubmit({
                      'allocationNo': that.formData.allocationNo,
                      'outSellerId': parseInt(that.formData.outSellerId),
                      'inSellerId': parseInt(that.formData.inSellerId),
                      'allocationRemark': that.formData.allocationRemark
                    }).then(function (res) {
                      // eslint-disable-next-line eqeqeq
                      if (res.code == 0) {
                        that.$message({
                          type: 'success',
                          message: res.msg
                        });
                        that.enterDialogRepose(res);
                      } // eslint-disable-next-line handle-callback-err

                    }, function (error) {});
                  }
                });

              case 3:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }))();
    },
    // 接收保存
    handleAccpet: function handleAccpet() {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var that;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                that = _this14;
                debugger;
                that.$refs['acceptForm'].validate(function (valid) {
                  if (valid) {
                    that.goodsAllocationDetailTableData.every(function (item) {
                      if (!item.goodsNo || item.goodsNo === '') {
                        valid = false;
                        that.$message({
                          type: 'warning',
                          message: '商品【' + item.goodsName + '】，请扫条形码'
                        });
                        return false;
                      }

                      return true;
                    });
                  }

                  if (valid) {
                    goodsAllocationCheck({
                      'allocationNo': that.formData.allocationNo,
                      'outSellerId': parseInt(that.formData.outSellerId),
                      'inSellerId': parseInt(that.formData.inSellerId),
                      'allocationStatus': parseInt(that.formData.allocationStatus),
                      'acceptRemark': that.formData.acceptRemark,
                      'list': that.goodsAllocationDetailTableData
                    }).then(function (res) {
                      // eslint-disable-next-line eqeqeq
                      if (res.code == 0) {
                        that.$message({
                          type: 'success',
                          message: res.msg
                        });
                        that.enterDialogRepose(res);
                      } // eslint-disable-next-line handle-callback-err

                    }, function (error) {});
                  }
                });

              case 3:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }))();
    }
  }
};